<script setup>
import { ref, onMounted, getCurrentInstance, computed } from 'vue'
import { useRouter } from 'vue-router'
import {usePageLoadingStore} from "../../../../stores/pageLoading";
import {useUserLectureStore} from "../../stores/lecture/userLectureStore";
import moment from 'moment'
import jobFairGnbService from "@/pages/user/services/jobFair/jobFairGnbService";
import {useUserStore} from "@/pages/user/stores/user";

const router = useRouter()
const loadingStore = usePageLoadingStore()
const userLectureStore = useUserLectureStore()

const list = ref([]);
const listIng = ref([]);
const currentPage = ref(1);
const pageSize = 30;
const totalPages = ref(1);
const totalCount = ref(0);

onMounted(() => {
  retrieveList();
  retrieveListIng();
})

// 기업공채관 현황 탭
const ojfStateGbOptionTab = ref('00,01,02,04');
const ojfStateGbOptions = ref([
  {label:'전체', value:'00,01,02,04'}, // 00: 신청 대기, 01: 신청 접수중, 02: 신청 마감, 04: 행사 종료
  {label:'진행중', value:'03'}, // 03: 행사 진행중
  {label:'종료', value:'04'} // 04: 행사종료
])

const retrieveList = () => {
  let paramObj = {
    searchOjfStateGb: ojfStateGbOptionTab.value || "00,01,02,04",
    ojfGb: "01",
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 30,
  }

  loadingStore.loading = true;
  jobFairGnbService.ojfGnbList(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = result.content;
        } else {
          totalPages.value = 0;
          totalCount.value = 0;
          list.value = [];
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 진행중 목록
const retrieveListIng = () => {
  let paramObj = {
    searchOjfStateGb: "03",
    ojfGb: "01",
    pageNumber: 0,
    size: 100,
  }

  loadingStore.loading = true;
  jobFairGnbService.ojfGnbList(paramObj)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          listIng.value = result.content;
        } else {
          totalPages.value = 0;
          totalCount.value = 0;
          listIng.value = [];
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}


// 전체, 진행중, 종료
const onChangeTab = (option) => {
  ojfStateGbOptionTab.value = option.value;
  retrieveList();
}

// 페이지 클릭
const onSelectedPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

// 기업공채관 상세 페이지 이동
const goSpecialEmployDetailView = (ojfId) => {
  router.push({name: 'MatchingOpenRecruitmentDetail', params:{id: ojfId}})
}

// 기업공채관 썸네일 이미지 기간별 class name
const employImgClass = (employ) => {

  const { $isInRegPeriod } = getCurrentInstance().appContext.config.globalProperties;
  const { $isAfterRegEnd } = getCurrentInstance().appContext.config.globalProperties;

  if(employ.ojfStateGb === '00') {
    return 'waiting';
  } else if(employ.ojfStateGb === '01') {
    return 'app-open';
  } else if (employ.ojfStateGb === '02') {
    return 'app-close';
  } else if (employ.ojfStateGb === '03') {
    if ($isInRegPeriod(employ.regStartYmd, employ.regEndYmd)) {
      return 'event-ongoing';
    } else if ($isAfterRegEnd(employ.regEndYmd)) {
      return 'event-closed';
    } else {
      return 'event-open';
    }
  } else if (employ.ojfStateGb === '04') {
    return 'event-close';
  } else  {
    return '';
  }
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="title page-title">
        <h3>기업공채관</h3>
      </div>
      <div class="lecture-wrap">
        <KSATab class="tab-style_small" :options="ojfStateGbOptions" @change="onChangeTab"/>
        <!-- S: 진행중 -->
        <ul class="lecture-list mb-sm" v-if="ojfStateGbOptionTab === '03' || ojfStateGbOptionTab === '00,01,02,04'">
          <li v-for="employIng in listIng" @click="goSpecialEmployDetailView(employIng.ojfId)">
            <div class="lecture-img" :class="employImgClass(employIng)">
              <KSAImage :src="employIng.ojfThombDir"/>
            </div>
            <div class="lecture-text">
              <h4>{{ employIng.ojfName }}</h4>
              <div class="lecture-info">
                <p class="date">
                  <i>
                    <b>접수기간</b>
                    <span>
                      {{ $yyyymmdd(employIng.regStartYmd) }} ({{ $dateToWeekDayShort(employIng.regStartYmd) }})
                      ~
                      {{ $yyyymmdd(employIng.regEndYmd) }} ({{ $dateToWeekDayShort(employIng.regEndYmd) }})
                    </span>
                  </i>
                </p>
                <p class="date">
                  <i>
                    <b>행사기간</b>
                    <span>
                      {{ $yyyymmdd(employIng.ojfStartYmd) }} ({{ $dateToWeekDayShort(employIng.ojfStartYmd) }})
                      ~
                      {{ $yyyymmdd(employIng.ojfEndYmd) }} ({{ $dateToWeekDayShort(employIng.ojfEndYmd) }})
                    </span>
                  </i>
                </p>
                <p class="date">
                  <i>
                    <b>장소</b>
                    <span>{{ employIng.ojfPlace }}</span>
                  </i>
                </p>
                <p class="date">
                  <i>
                    <b>주최</b>
                    <span>{{ employIng.ojfHost }}</span>
                  </i>
                </p>
              </div>
              <div class="lecture-content">{{ employIng.lectDesc }}</div>
            </div>
          </li>
        </ul>
        <!-- E: 진행중 -->
        <!-- S: 전체 -->
        <ul class="lecture-list"
            :style="( ['04','00,01,02,04'].includes(ojfStateGbOptionTab) && list.length === 0 )
            ? { borderBottom: '0' }
            : {}"
            v-if="ojfStateGbOptionTab === '04' || ojfStateGbOptionTab === '00,01,02,04'">
          <li v-for="employ in list" @click="goSpecialEmployDetailView(employ.ojfId)">
            <div class="lecture-img" :class="employImgClass(employ)">
              <KSAImage :src="employ.ojfThombDir"/>
            </div>
            <div class="lecture-text">
              <h4>{{ employ.ojfName }}</h4>
              <div class="lecture-info">
                <p class="date">
                  <i>
                    <b>접수기간</b>
                    <span>
                      {{ $yyyymmdd(employ.regStartYmd) }} ({{ $dateToWeekDayShort(employ.regStartYmd) }})
                      ~
                      {{ $yyyymmdd(employ.regEndYmd) }} ({{ $dateToWeekDayShort(employ.regEndYmd) }})
                    </span>
                  </i>
                </p>
                <p class="date">
                  <i>
                    <b>행사기간</b>
                    <span>
                      {{ $yyyymmdd(employ.ojfStartYmd) }} ({{ $dateToWeekDayShort(employ.ojfStartYmd) }})
                      ~
                      {{ $yyyymmdd(employ.ojfEndYmd) }} ({{ $dateToWeekDayShort(employ.ojfEndYmd) }})
                    </span>
                  </i>
                </p>
                <p class="date">
                  <i>
                    <b>장소</b>
                    <span>{{ employ.ojfPlace }}</span>
                  </i>
                </p>
                <p class="date">
                  <i>
                    <b>주최</b>
                    <span>{{ employ.ojfHost }}</span>
                  </i>
                </p>
              </div>
              <div class="lecture-content">{{ employ.lectDesc }}</div>
            </div>
          </li>
        </ul>
        <div class="result-none lecture-none" v-if="(list.length === 0 && listIng.length === 0) || (ojfStateGbOptionTab === '04' && list.length === 0) || (ojfStateGbOptionTab === '03' && listIng.length === 0)">
          검색 결과가 없습니다.
        </div>
      </div>
      <Paginate
          v-if="list.length > 0"
          v-model="currentPage"
          :page-count="totalPages"
          :click-handler="onSelectedPage"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.lecture-list {
  li {
    cursor: pointer;
    .lecture-text {
      h4 {
        margin-bottom: 20px;
      }
      .lecture-info {
        p.date {
          b {
            display: inline-block;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
